import { render } from "./AnalyticsLeaderboard.vue?vue&type=template&id=682da560"
import script from "./AnalyticsLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsLeaderboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Analytics/AnalyticsLeaderboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "682da560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('682da560', __exports__)) {
    api.reload('682da560', __exports__)
  }
  
  module.hot.accept("./AnalyticsLeaderboard.vue?vue&type=template&id=682da560", () => {
    api.rerender('682da560', render)
  })

}


export default __exports__